// extracted by mini-css-extract-plugin
export default {"colorOrange":"#ff6332","headerTitle":"headerTitle__1dxHV","formElement":"formElement__1HwUh","formInputsContainer":"formInputsContainer__2M2hN","footerButton":"footerButton__z2I1M","footerButtonCenter":"footerButtonCenter__2A1zV","totalPrice":"totalPrice__2q2Ok","totalTitle":"totalTitle__3Locw","ccImgContainer":"ccImgContainer__3NmQv","price":"price__1Nv1R"};
    if(module.hot) {
      // 1778491671496
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  